module.exports = __webpack_public_path__ + "static/media/Vinnande Team.57b68a0e.pdf";